module.exports = __webpack_public_path__ + "img/bd.68e95da7.svg";